/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex-schema'

const $nsid = 'community.lexicon.app.defs'

type $nsid = typeof $nsid

export { $nsid }

/** A labeled URI associated with an app. */
type Link = {
  $type?: 'community.lexicon.app.defs#link'

  /**
   * Destination URI.
   */
  uri: l.UriString

  /**
   * Human-readable label for the URI.
   */
  label?: string

  /**
   * Known role of this link, if any.
   */
  role?: LinkRole
}

export type { Link }

/** A labeled URI associated with an app. */
const link = /*#__PURE__*/ l.typedObject<Link>(
  $nsid,
  'link',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string({ format: 'uri' }),
    label: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 100, maxGraphemes: 50 }),
    ),
    role: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<LinkRole>((() => linkRole) as any),
    ),
  }),
)

export { link }

/** Known role of a link associated with an app. */
type LinkRole =
  | 'community.lexicon.app.defs#linkRoleWebsite'
  | 'community.lexicon.app.defs#linkRoleWebManifest'
  | 'community.lexicon.app.defs#linkRolePrivacyPolicy'
  | 'community.lexicon.app.defs#linkRoleTermsOfService'
  | 'community.lexicon.app.defs#linkRoleSupport'
  | 'community.lexicon.app.defs#linkRoleSourceCode'
  | 'community.lexicon.app.defs#linkRoleDocs'
  | 'community.lexicon.app.defs#linkRoleChangelog'
  | 'community.lexicon.app.defs#linkRoleStatus'
  | 'community.lexicon.app.defs#linkRoleAppStore'
  | 'community.lexicon.app.defs#linkRolePlayStore'
  | 'community.lexicon.app.defs#linkRoleFDroid'
  | l.UnknownString

export type { LinkRole }

/** Known role of a link associated with an app. */
const linkRole = /*#__PURE__*/ l.string<{
  knownValues: [
    'community.lexicon.app.defs#linkRoleWebsite',
    'community.lexicon.app.defs#linkRoleWebManifest',
    'community.lexicon.app.defs#linkRolePrivacyPolicy',
    'community.lexicon.app.defs#linkRoleTermsOfService',
    'community.lexicon.app.defs#linkRoleSupport',
    'community.lexicon.app.defs#linkRoleSourceCode',
    'community.lexicon.app.defs#linkRoleDocs',
    'community.lexicon.app.defs#linkRoleChangelog',
    'community.lexicon.app.defs#linkRoleStatus',
    'community.lexicon.app.defs#linkRoleAppStore',
    'community.lexicon.app.defs#linkRolePlayStore',
    'community.lexicon.app.defs#linkRoleFDroid',
  ]
}>()

export { linkRole }

/** Primary website or landing page. */
const linkRoleWebsite = /*#__PURE__*/ l.token($nsid, 'linkRoleWebsite')

export { linkRoleWebsite }

/** Primary website or landing page. */
const LinkRoleWebsite = /*#__PURE__*/ linkRoleWebsite.value

/** Primary website or landing page. */
type LinkRoleWebsite = typeof LinkRoleWebsite

export { LinkRoleWebsite }

/** Web App Manifest. */
const linkRoleWebManifest = /*#__PURE__*/ l.token($nsid, 'linkRoleWebManifest')

export { linkRoleWebManifest }

/** Web App Manifest. */
const LinkRoleWebManifest = /*#__PURE__*/ linkRoleWebManifest.value

/** Web App Manifest. */
type LinkRoleWebManifest = typeof LinkRoleWebManifest

export { LinkRoleWebManifest }

/** Privacy policy. */
const linkRolePrivacyPolicy = /*#__PURE__*/ l.token(
  $nsid,
  'linkRolePrivacyPolicy',
)

export { linkRolePrivacyPolicy }

/** Privacy policy. */
const LinkRolePrivacyPolicy = /*#__PURE__*/ linkRolePrivacyPolicy.value

/** Privacy policy. */
type LinkRolePrivacyPolicy = typeof LinkRolePrivacyPolicy

export { LinkRolePrivacyPolicy }

/** Terms of service. */
const linkRoleTermsOfService = /*#__PURE__*/ l.token(
  $nsid,
  'linkRoleTermsOfService',
)

export { linkRoleTermsOfService }

/** Terms of service. */
const LinkRoleTermsOfService = /*#__PURE__*/ linkRoleTermsOfService.value

/** Terms of service. */
type LinkRoleTermsOfService = typeof LinkRoleTermsOfService

export { LinkRoleTermsOfService }

/** Support, help, or contact page. */
const linkRoleSupport = /*#__PURE__*/ l.token($nsid, 'linkRoleSupport')

export { linkRoleSupport }

/** Support, help, or contact page. */
const LinkRoleSupport = /*#__PURE__*/ linkRoleSupport.value

/** Support, help, or contact page. */
type LinkRoleSupport = typeof LinkRoleSupport

export { LinkRoleSupport }

/** Source code repository or source distribution. */
const linkRoleSourceCode = /*#__PURE__*/ l.token($nsid, 'linkRoleSourceCode')

export { linkRoleSourceCode }

/** Source code repository or source distribution. */
const LinkRoleSourceCode = /*#__PURE__*/ linkRoleSourceCode.value

/** Source code repository or source distribution. */
type LinkRoleSourceCode = typeof LinkRoleSourceCode

export { LinkRoleSourceCode }

/** Documentation. */
const linkRoleDocs = /*#__PURE__*/ l.token($nsid, 'linkRoleDocs')

export { linkRoleDocs }

/** Documentation. */
const LinkRoleDocs = /*#__PURE__*/ linkRoleDocs.value

/** Documentation. */
type LinkRoleDocs = typeof LinkRoleDocs

export { LinkRoleDocs }

/** Changelog or release notes. */
const linkRoleChangelog = /*#__PURE__*/ l.token($nsid, 'linkRoleChangelog')

export { linkRoleChangelog }

/** Changelog or release notes. */
const LinkRoleChangelog = /*#__PURE__*/ linkRoleChangelog.value

/** Changelog or release notes. */
type LinkRoleChangelog = typeof LinkRoleChangelog

export { LinkRoleChangelog }

/** Service status page. */
const linkRoleStatus = /*#__PURE__*/ l.token($nsid, 'linkRoleStatus')

export { linkRoleStatus }

/** Service status page. */
const LinkRoleStatus = /*#__PURE__*/ linkRoleStatus.value

/** Service status page. */
type LinkRoleStatus = typeof LinkRoleStatus

export { LinkRoleStatus }

/** Apple App Store listing. */
const linkRoleAppStore = /*#__PURE__*/ l.token($nsid, 'linkRoleAppStore')

export { linkRoleAppStore }

/** Apple App Store listing. */
const LinkRoleAppStore = /*#__PURE__*/ linkRoleAppStore.value

/** Apple App Store listing. */
type LinkRoleAppStore = typeof LinkRoleAppStore

export { LinkRoleAppStore }

/** Google Play Store listing. */
const linkRolePlayStore = /*#__PURE__*/ l.token($nsid, 'linkRolePlayStore')

export { linkRolePlayStore }

/** Google Play Store listing. */
const LinkRolePlayStore = /*#__PURE__*/ linkRolePlayStore.value

/** Google Play Store listing. */
type LinkRolePlayStore = typeof LinkRolePlayStore

export { LinkRolePlayStore }

/** F-Droid listing. */
const linkRoleFDroid = /*#__PURE__*/ l.token($nsid, 'linkRoleFDroid')

export { linkRoleFDroid }

/** F-Droid listing. */
const LinkRoleFDroid = /*#__PURE__*/ linkRoleFDroid.value

/** F-Droid listing. */
type LinkRoleFDroid = typeof LinkRoleFDroid

export { LinkRoleFDroid }

/** An image associated with an app, including accessibility and display metadata. Exactly one of `image` (ATProto blob) or `uri` (remote URL) MUST be present. Consumers SHOULD ignore image items that have neither or both. */
type Image = {
  $type?: 'community.lexicon.app.defs#image'

  /**
   * How directories and stores should use the image. Omit this field when no known purpose fits.
   */
  purpose?:
    | 'community.lexicon.app.defs#purposeIcon'
    | 'community.lexicon.app.defs#purposeLogo'
    | 'community.lexicon.app.defs#purposeHero'
    | 'community.lexicon.app.defs#purposeScreenshot'
    | 'community.lexicon.app.defs#purposeBanner'
    | 'community.lexicon.app.defs#purposeSocialCard'
    | 'community.lexicon.app.defs#purposeAppStore'
    | 'community.lexicon.app.defs#purposeAd'
    | l.UnknownString

  /**
   * The raw image file.
   */
  image?: l.BlobRef

  /**
   * Remote image URI.
   */
  uri?: l.UriString

  /**
   * Alt text description of the image, for accessibility.
   */
  alt: string
  aspectRatio?: AspectRatio
}

export type { Image }

/** An image associated with an app, including accessibility and display metadata. Exactly one of `image` (ATProto blob) or `uri` (remote URL) MUST be present. Consumers SHOULD ignore image items that have neither or both. */
const image = /*#__PURE__*/ l.typedObject<Image>(
  $nsid,
  'image',
  /*#__PURE__*/ l.object({
    purpose: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'community.lexicon.app.defs#purposeIcon',
          'community.lexicon.app.defs#purposeLogo',
          'community.lexicon.app.defs#purposeHero',
          'community.lexicon.app.defs#purposeScreenshot',
          'community.lexicon.app.defs#purposeBanner',
          'community.lexicon.app.defs#purposeSocialCard',
          'community.lexicon.app.defs#purposeAppStore',
          'community.lexicon.app.defs#purposeAd',
        ]
      }>(),
    ),
    image: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.blob({ accept: ['image/*'], maxSize: 2000000 }),
    ),
    uri: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'uri' })),
    alt: /*#__PURE__*/ l.string({ maxLength: 1000, maxGraphemes: 300 }),
    aspectRatio: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<AspectRatio>((() => aspectRatio) as any),
    ),
  }),
)

export { image }

/** width:height represents an aspect ratio. It may be approximate. */
type AspectRatio = {
  $type?: 'community.lexicon.app.defs#aspectRatio'
  width: number
  height: number
}

export type { AspectRatio }

/** width:height represents an aspect ratio. It may be approximate. */
const aspectRatio = /*#__PURE__*/ l.typedObject<AspectRatio>(
  $nsid,
  'aspectRatio',
  /*#__PURE__*/ l.object({
    width: /*#__PURE__*/ l.integer({ minimum: 1 }),
    height: /*#__PURE__*/ l.integer({ minimum: 1 }),
  }),
)

export { aspectRatio }

/** A small square icon representing the app, typically used in launchers, lists, and tab bars. */
const purposeIcon = /*#__PURE__*/ l.token($nsid, 'purposeIcon')

export { purposeIcon }

/** A small square icon representing the app, typically used in launchers, lists, and tab bars. */
const PurposeIcon = /*#__PURE__*/ purposeIcon.value

/** A small square icon representing the app, typically used in launchers, lists, and tab bars. */
type PurposeIcon = typeof PurposeIcon

export { PurposeIcon }

/** A logotype or wordmark for the app. */
const purposeLogo = /*#__PURE__*/ l.token($nsid, 'purposeLogo')

export { purposeLogo }

/** A logotype or wordmark for the app. */
const PurposeLogo = /*#__PURE__*/ purposeLogo.value

/** A logotype or wordmark for the app. */
type PurposeLogo = typeof PurposeLogo

export { PurposeLogo }

/** A large promotional or feature image, typically used at the top of a directory listing. */
const purposeHero = /*#__PURE__*/ l.token($nsid, 'purposeHero')

export { purposeHero }

/** A large promotional or feature image, typically used at the top of a directory listing. */
const PurposeHero = /*#__PURE__*/ purposeHero.value

/** A large promotional or feature image, typically used at the top of a directory listing. */
type PurposeHero = typeof PurposeHero

export { PurposeHero }

/** A screenshot of the app's UI, used in directory and store listings. */
const purposeScreenshot = /*#__PURE__*/ l.token($nsid, 'purposeScreenshot')

export { purposeScreenshot }

/** A screenshot of the app's UI, used in directory and store listings. */
const PurposeScreenshot = /*#__PURE__*/ purposeScreenshot.value

/** A screenshot of the app's UI, used in directory and store listings. */
type PurposeScreenshot = typeof PurposeScreenshot

export { PurposeScreenshot }

/** A wide banner image, such as a header image for a profile or listing page. */
const purposeBanner = /*#__PURE__*/ l.token($nsid, 'purposeBanner')

export { purposeBanner }

/** A wide banner image, such as a header image for a profile or listing page. */
const PurposeBanner = /*#__PURE__*/ purposeBanner.value

/** A wide banner image, such as a header image for a profile or listing page. */
type PurposeBanner = typeof PurposeBanner

export { PurposeBanner }

/** An image sized and formatted for social media sharing previews (Open Graph, Twitter Card, etc.). */
const purposeSocialCard = /*#__PURE__*/ l.token($nsid, 'purposeSocialCard')

export { purposeSocialCard }

/** An image sized and formatted for social media sharing previews (Open Graph, Twitter Card, etc.). */
const PurposeSocialCard = /*#__PURE__*/ purposeSocialCard.value

/** An image sized and formatted for social media sharing previews (Open Graph, Twitter Card, etc.). */
type PurposeSocialCard = typeof PurposeSocialCard

export { PurposeSocialCard }

/** A promotional image formatted for a native app store listing. */
const purposeAppStore = /*#__PURE__*/ l.token($nsid, 'purposeAppStore')

export { purposeAppStore }

/** A promotional image formatted for a native app store listing. */
const PurposeAppStore = /*#__PURE__*/ purposeAppStore.value

/** A promotional image formatted for a native app store listing. */
type PurposeAppStore = typeof PurposeAppStore

export { PurposeAppStore }

/** A promotional or advertising image. */
const purposeAd = /*#__PURE__*/ l.token($nsid, 'purposeAd')

export { purposeAd }

/** A promotional or advertising image. */
const PurposeAd = /*#__PURE__*/ purposeAd.value

/** A promotional or advertising image. */
type PurposeAd = typeof PurposeAd

export { PurposeAd }

/** Current release or maintenance status of an app. */
type Status =
  | 'community.lexicon.app.defs#unreleased'
  | 'community.lexicon.app.defs#preview'
  | 'community.lexicon.app.defs#released'
  | 'community.lexicon.app.defs#unmaintained'
  | 'community.lexicon.app.defs#discontinued'
  | l.UnknownString

export type { Status }

/** Current release or maintenance status of an app. */
const status = /*#__PURE__*/ l.string<{
  knownValues: [
    'community.lexicon.app.defs#unreleased',
    'community.lexicon.app.defs#preview',
    'community.lexicon.app.defs#released',
    'community.lexicon.app.defs#unmaintained',
    'community.lexicon.app.defs#discontinued',
  ]
}>()

export { status }

/** The app has been announced but is not yet available. */
const unreleased = /*#__PURE__*/ l.token($nsid, 'unreleased')

export { unreleased }

/** The app has been announced but is not yet available. */
const Unreleased = /*#__PURE__*/ unreleased.value

/** The app has been announced but is not yet available. */
type Unreleased = typeof Unreleased

export { Unreleased }

/** The app is available as an alpha, beta, early access, or preview release. */
const preview = /*#__PURE__*/ l.token($nsid, 'preview')

export { preview }

/** The app is available as an alpha, beta, early access, or preview release. */
const Preview = /*#__PURE__*/ preview.value

/** The app is available as an alpha, beta, early access, or preview release. */
type Preview = typeof Preview

export { Preview }

/** The app is generally available. */
const released = /*#__PURE__*/ l.token($nsid, 'released')

export { released }

/** The app is generally available. */
const Released = /*#__PURE__*/ released.value

/** The app is generally available. */
type Released = typeof Released

export { Released }

/** The app may still be available, but is no longer actively maintained. */
const unmaintained = /*#__PURE__*/ l.token($nsid, 'unmaintained')

export { unmaintained }

/** The app may still be available, but is no longer actively maintained. */
const Unmaintained = /*#__PURE__*/ unmaintained.value

/** The app may still be available, but is no longer actively maintained. */
type Unmaintained = typeof Unmaintained

export { Unmaintained }

/** The app is no longer available or supported. */
const discontinued = /*#__PURE__*/ l.token($nsid, 'discontinued')

export { discontinued }

/** The app is no longer available or supported. */
const Discontinued = /*#__PURE__*/ discontinued.value

/** The app is no longer available or supported. */
type Discontinued = typeof Discontinued

export { Discontinued }

/** Platform where an app is available. */
type Platform =
  | 'community.lexicon.app.defs#platformWeb'
  | 'community.lexicon.app.defs#platformIOS'
  | 'community.lexicon.app.defs#platformAndroid'
  | 'community.lexicon.app.defs#platformMacOS'
  | 'community.lexicon.app.defs#platformWindows'
  | 'community.lexicon.app.defs#platformLinux'
  | 'community.lexicon.app.defs#platformCLI'
  | l.UnknownString

export type { Platform }

/** Platform where an app is available. */
const platform = /*#__PURE__*/ l.string<{
  knownValues: [
    'community.lexicon.app.defs#platformWeb',
    'community.lexicon.app.defs#platformIOS',
    'community.lexicon.app.defs#platformAndroid',
    'community.lexicon.app.defs#platformMacOS',
    'community.lexicon.app.defs#platformWindows',
    'community.lexicon.app.defs#platformLinux',
    'community.lexicon.app.defs#platformCLI',
  ]
}>()

export { platform }

/** Web app or website. */
const platformWeb = /*#__PURE__*/ l.token($nsid, 'platformWeb')

export { platformWeb }

/** Web app or website. */
const PlatformWeb = /*#__PURE__*/ platformWeb.value

/** Web app or website. */
type PlatformWeb = typeof PlatformWeb

export { PlatformWeb }

/** iOS app. */
const platformIOS = /*#__PURE__*/ l.token($nsid, 'platformIOS')

export { platformIOS }

/** iOS app. */
const PlatformIos = /*#__PURE__*/ platformIOS.value

/** iOS app. */
type PlatformIos = typeof PlatformIos

export { PlatformIos }

/** Android app. */
const platformAndroid = /*#__PURE__*/ l.token($nsid, 'platformAndroid')

export { platformAndroid }

/** Android app. */
const PlatformAndroid = /*#__PURE__*/ platformAndroid.value

/** Android app. */
type PlatformAndroid = typeof PlatformAndroid

export { PlatformAndroid }

/** macOS app. */
const platformMacOS = /*#__PURE__*/ l.token($nsid, 'platformMacOS')

export { platformMacOS }

/** macOS app. */
const PlatformMacOs = /*#__PURE__*/ platformMacOS.value

/** macOS app. */
type PlatformMacOs = typeof PlatformMacOs

export { PlatformMacOs }

/** Windows app. */
const platformWindows = /*#__PURE__*/ l.token($nsid, 'platformWindows')

export { platformWindows }

/** Windows app. */
const PlatformWindows = /*#__PURE__*/ platformWindows.value

/** Windows app. */
type PlatformWindows = typeof PlatformWindows

export { PlatformWindows }

/** Linux app. */
const platformLinux = /*#__PURE__*/ l.token($nsid, 'platformLinux')

export { platformLinux }

/** Linux app. */
const PlatformLinux = /*#__PURE__*/ platformLinux.value

/** Linux app. */
type PlatformLinux = typeof PlatformLinux

export { PlatformLinux }

/** Command line interface. */
const platformCLI = /*#__PURE__*/ l.token($nsid, 'platformCLI')

export { platformCLI }

/** Command line interface. */
const PlatformCli = /*#__PURE__*/ platformCLI.value

/** Command line interface. */
type PlatformCli = typeof PlatformCli

export { PlatformCli }

/** Self-declared AT Protocol lexicon interoperability signals. */
type LexiconInterop = {
  $type?: 'community.lexicon.app.defs#lexiconInterop'

  /**
   * Lexicon collections this app creates or publishes records for.
   */
  produces?: l.NsidString[]

  /**
   * Lexicon collections this app reads, displays, imports, or otherwise consumes.
   */
  consumes?: l.NsidString[]
}

export type { LexiconInterop }

/** Self-declared AT Protocol lexicon interoperability signals. */
const lexiconInterop = /*#__PURE__*/ l.typedObject<LexiconInterop>(
  $nsid,
  'lexiconInterop',
  /*#__PURE__*/ l.object({
    produces: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'nsid' })),
    ),
    consumes: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'nsid' })),
    ),
  }),
)

export { lexiconInterop }

/** A record whose presence in an account can indicate that the account probably uses this app. */
type AccountIndicator = {
  $type?: 'community.lexicon.app.defs#accountIndicator'

  /**
   * Record collection to look for in an account repository.
   */
  collection: l.NsidString

  /**
   * Optional record key to look for within the collection.
   */
  rkey?: l.RecordKeyString
}

export type { AccountIndicator }

/** A record whose presence in an account can indicate that the account probably uses this app. */
const accountIndicator = /*#__PURE__*/ l.typedObject<AccountIndicator>(
  $nsid,
  'accountIndicator',
  /*#__PURE__*/ l.object({
    collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
    rkey: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'record-key' }),
    ),
  }),
)

export { accountIndicator }
